import { render, staticRenderFns } from "./remoteVipSelect.vue?vue&type=template&id=761fd8e6&scoped=true&"
import script from "./remoteVipSelect.vue?vue&type=script&lang=js&"
export * from "./remoteVipSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761fd8e6",
  null
  
)

export default component.exports